import { render } from "./FormBoxes.vue?vue&type=template&id=fe6ba102"
import script from "./FormBoxes.vue?vue&type=script&lang=js"
export * from "./FormBoxes.vue?vue&type=script&lang=js"
script.render = render

export default script